import {
  ExtractDisplayDataFn,
  FetchDataFn,
  FinalizeRecordFn,
  InitializeRecordFn,
  PrepareIntermediateFn,
  RefineResultFn,
} from '../../models/GameControllerStore';
import {
  GameControllerDefaultParams,
  preprocess as defaultPreprocess,
} from './mode-default';
import {
  GameControllerRecordParams,
  preprocess as recordPreprocess,
} from './mode-record';

export * from './store';

export enum GameMode {
  Default = 'default',
  // Challenge = 'challenge',
  // Practice = 'practice',
  // PartChallenge = 'partChallenge',
  Record = 'record',
  // MiniChallenge = 'miniChallenge',
  // PathChallenge = 'pathChallenge',
  Improvement = 'Improvement', // TODO
  Preview = 'Preview', // TODO
  PostGame = 'PostGame', // TODO
  MillionaireChallenge = 'MillionaireChallenge', // TODO
}

export type GameParams<M extends GameMode> = M extends GameMode.Default
  ? GameControllerDefaultParams
  : M extends GameMode.Record
  ? GameControllerRecordParams
  : never;

export const createGameParams = <M extends GameMode>(
  params: GameParams<M> & { mode: M },
) => {
  return params;
};

export const GAME_MODE_SETUP_FN: {
  [m in GameMode]: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extractDisplayData: ExtractDisplayDataFn<any, any, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    prepareIntermediate: PrepareIntermediateFn<any, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fetchData: FetchDataFn<any, any, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    refineResult: RefineResultFn<any, any, any, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    initializeRecord: InitializeRecordFn<any, any, any, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    finalizeRecord: FinalizeRecordFn<any, any, any, any>;
  };
} = {
  [GameMode.Default]: defaultPreprocess,
  // [GameMode.Challenge]: challengePreprocess,
  // [GameMode.Practice]: practicePreprocess,
  // [GameMode.PartChallenge]: partChallengePreprocess,
  [GameMode.Record]: recordPreprocess,
  // [GameMode.MiniChallenge]: challengePreprocess,
  // [GameMode.PathChallenge]: challengePreprocess,
  [GameMode.Improvement]: defaultPreprocess, // TODO
  [GameMode.Preview]: defaultPreprocess, // TODO
  [GameMode.PostGame]: defaultPreprocess, // TODO
  [GameMode.MillionaireChallenge]: defaultPreprocess, // TODO
};
